import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { SharedModule } from '../core/modules/shared.module';

import { EguardMainComponent } from './main.component';
import { EguardComponent } from './content/eguard.component';
import { CommonModule } from './content/common.module';
import { EguardFooterComponent } from './shared/components/footer/footer.component';
import { EguardNavbarVerticalComponent } from './shared/components/navbar/vertical/navbar-vertical.component';
import { EguardToolbarComponent } from './shared/components/toolbar/toolbar.component';
import { EguardNavigationModule } from '../core/components/navigation/navigation.module';
import { EguardNavbarVerticalToggleDirective } from './shared/components/navbar/vertical/navbar-vertical-toggle.directive';
import { EguardNavbarHorizontalComponent } from './shared/components/navbar/horizontal/navbar-horizontal.component';
import { EguardQuickPanelComponent } from './shared/components/quick-panel/quick-panel.component';
import { EguardThemeOptionsComponent } from '../core/components/theme-options/theme-options.component';
import { EguardShortcutsModule } from '../core/components/shortcuts/shortcuts.module';
import { EguardSearchBarModule } from '../core/components/search-bar/search-bar.module';
import { EguardCustomLoaderComponent } from '../core/components/custom-loader/custom-loader.component';
import { EguardCustomLoaderService } from '../core/components/custom-loader/custom-loader.service';
import { ConfirmationDialogComponent } from './shared/dialog/confirmation-dialog/confirmation-dialog.component';
import { UserDetailsDialogComponent } from './shared/dialog/user-details-dialog/user-details-dialog.component';
import { LocalUserService } from './shared/services/localUser';
import { AddNewActivityDialogComponent } from './shared/dialog/add-new-activity-dialog/add-new-activity-dialog.component';
import { MomentModule } from 'angular2-moment';
import { NgIdleKeepaliveModule } from '@ng-idle/keepalive';
import { TimeOutDialogComponent } from './shared/dialog/time-out-dialog/time-out-dialog.component';
import { DataShareService } from './shared/services/data-share.service';
import { GuardianConfirmationDialogComponent } from './shared/dialog/guardian-confirmation-dialog/guardian-confirmation-dialog.component';
import { GuardianUploadDocDialogComponent } from './shared/dialog/guardian-upload-doc-dialog/guardian-upload-doc-dialog.component';
import { TownDialogComponent } from './shared/dialog/town-dialog/town-dialog.component';


@NgModule({
    declarations: [
        EguardComponent,
        EguardFooterComponent,
        EguardMainComponent,
        EguardNavbarVerticalComponent,
        EguardNavbarHorizontalComponent,
        EguardToolbarComponent,
        EguardNavbarVerticalToggleDirective,
        EguardThemeOptionsComponent,
        EguardQuickPanelComponent,
        EguardCustomLoaderComponent,
        ConfirmationDialogComponent,
        UserDetailsDialogComponent,
        AddNewActivityDialogComponent,
        TimeOutDialogComponent,
        GuardianConfirmationDialogComponent,
        GuardianUploadDocDialogComponent,
        TownDialogComponent
    ],
    imports: [
        SharedModule,
        RouterModule,
        CommonModule,
        EguardNavigationModule,
        EguardShortcutsModule,
        EguardSearchBarModule,
        SharedModule,
        MomentModule,
        NgIdleKeepaliveModule.forRoot()
    ],
    exports: [
        EguardMainComponent
    ],
    providers: [EguardCustomLoaderService, LocalUserService, DataShareService],
    entryComponents: [
        ConfirmationDialogComponent,
        UserDetailsDialogComponent,
        AddNewActivityDialogComponent,
        TimeOutDialogComponent,
        GuardianConfirmationDialogComponent,
        GuardianUploadDocDialogComponent,
        TownDialogComponent
    ]
})

export class EguardMainModule {
}



// WEBPACK FOOTER //
// ./src/app/main/main.module.ts